import React from 'react';
import { AVAILABLE_OPERATORS } from '../../../constants/policy';
import type { OperatorSelectProps } from '../types';

/**
 * OperatorSelect component for choosing logical operators
 * 
 * This component renders a dropdown select element that allows users to choose
 * from available logical operators (defined in AVAILABLE_OPERATORS constant).
 * It's used within the Condition Editor to set the operator for condition statements.
 * 
 * @example
 * <OperatorSelect
 *   value={currentOperator}
 *   onChange={handleOperatorChange}
 * />
 */
export const OperatorSelect: React.FC<OperatorSelectProps> = ({ value, onChange }) => (
  <select 
    value={value} 
    onChange={(e) => onChange(e.target.value)}
    className="block w-full h-10 rounded-md border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 px-3 py-2 text-base text-gray-800 dark:text-gray-200 focus:border-blue-500 focus:ring-blue-500"
  >
    {AVAILABLE_OPERATORS.map(op => (
      <option key={op} value={op}>{op}</option>
    ))}
  </select>
); 